import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as ZonesIcon } from '../../../../../assets/zones.svg';

export default function NoZonesHeader (props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'zonesPage' });

    return (
        <div className="no-zones-heaader">
            <ZonesIcon/>
            <h3>{t('noZonesCreated')}</h3>
            <div className="no-zones-subheader">{t('noZonesDescription')}</div>
        </div>
    )
}
